import * as fromStaticDataCountries from './static-data-countries.reducer';
import * as fromStaticDataCountriesForSettings from './static-data-countries-for-settings.reducer';
import * as fromStaticDataUserRolesReducer from './user-roles.reducer';
import * as fromStaticDataAllUserRolesReducer from './all-roles.reducer';
import * as fromStaticDataLegalEntityUserRolesReducer from './legal-entity-user-roles.reducer';
import * as fromStaticDataBusinessNamesReducer from './business-names.reducer';
import * as fromStaticDataProductNamesReducer from './products.reducer';
import * as fromStaticDataRejectionReasonReducer from './uploaded-file-rejection-reason.reducer';
import * as fromStaticDataBankReducer from './banks.reducer';
import * as fromStaticDataAVCFrequencyReducer from './avc-frequencies.reducer';
import * as fromStaticDataTaxCertificates from './tax-certificate-type.reducer';
import * as fromStaticDataUploadedFileTypeReducer from './uploaded-file-types.reducer';
import * as fromStaticDataProductTypeReducer from './product-types.reducer';
import * as fromStaticDataProductSubTypeReducer from './product-sub-types.reducer';
import * as fromStaticDataProductSubTypeByTypeReducer from './product-sub-types-by-type.reducer';
import * as fromStaticDataProductCurrenciesReducer from './product-currencies.reducer';
import * as fromStaticDataProductOnboardingFormsReducer from './product-onboarding-forms.reducer';
import * as fromStaticDataProductStartingAgesReducer from './product-starting-ages.reducer';
import * as fromStaticDataProductRetirementAgesReducer from './product-retirement-ages.reducer';
import * as fromStaticDataProductSwitchLockPeriodsReducer from './product-switchlock-periods.reducer';
import * as fromStaticDataLockPeriodsReducer from './lock-periods.reducer';
import * as fromStaticDataProductAnnualSwitchLimitsReducer from './product-annual-switch-limits.reducer';
import * as fromStaticDataProductProvidersReducer from './product-providers.reducer';
import * as fromStaticDataProductGoalsReducer from './product-goals.reducer';
import * as fromStaticDataNotificationTypeReducer from './notification-types.reducer';
import * as fromStaticDataIndividualsReducer from './individuals.reducer';
import * as fromStaticDataBusinessGroupsReducer from './static-data-business-groups.reducer';
import * as fromStaticDataProductSolutionsReducer from './static-data-product-solutions.reducer';
import * as fromStaticDataPreferredContactMethodsReducer from './preferred-contact-methods.reducer';
import * as fromStaticDataBusinessUserStatusReducer from './business-user-status.reducer';
import * as fromStaticDataClientTypesReducer from './static-data-client-types.reducer';
import * as fromStaticDataComplianceStatusesReducer from './static-data-compliance-statuses.reducer';
import * as fromStaticDataJurisdictionRisksReducer from './static-data-jurisdiction-risks.reducer';
import * as fromStaticDataPepRisksReducer from './static-data-pep-risks.reducer';
import * as fromStaticDataMediaRisksReducer from './static-data-media-risks.reducer';
import * as fromStaticDataValueRisksReducer from './static-data-value-risks.reducer';
import * as fromProofOfBankDocumentTypesReducer from './proof-of-bank-document-types.reducer';
import * as fromProofOfAddressDocumentTypesReducer from './proof-of-address-document-types.reducer';
import * as fromAccountTypesReducer from './account-types.reducer';
import * as fromGoogleAPIKeyReducer from './google-api-key.reducer';
import * as fromWithdrawalRejectionReasonReducer from './withdrawal-rejection-reason.reducer';

export {
  fromStaticDataCountries,
  fromStaticDataCountriesForSettings,
  fromStaticDataUserRolesReducer,
  fromStaticDataAllUserRolesReducer,
  fromStaticDataLegalEntityUserRolesReducer,
  fromStaticDataBusinessNamesReducer,
  fromStaticDataProductNamesReducer,
  fromStaticDataRejectionReasonReducer,
  fromStaticDataBankReducer,
  fromStaticDataAVCFrequencyReducer,
  fromStaticDataTaxCertificates,
  fromStaticDataUploadedFileTypeReducer,
  fromStaticDataProductTypeReducer,
  fromStaticDataProductSubTypeReducer,
  fromStaticDataProductSubTypeByTypeReducer,
  fromStaticDataProductOnboardingFormsReducer,
  fromStaticDataProductCurrenciesReducer,
  fromStaticDataProductStartingAgesReducer,
  fromStaticDataProductRetirementAgesReducer,
  fromStaticDataProductSwitchLockPeriodsReducer,
  fromStaticDataLockPeriodsReducer,
  fromStaticDataProductAnnualSwitchLimitsReducer,
  fromStaticDataProductProvidersReducer,
  fromStaticDataProductGoalsReducer,
  fromStaticDataNotificationTypeReducer,
  fromStaticDataIndividualsReducer,
  fromStaticDataBusinessGroupsReducer,
  fromStaticDataProductSolutionsReducer,
  fromStaticDataPreferredContactMethodsReducer,
  fromStaticDataBusinessUserStatusReducer,
  fromStaticDataClientTypesReducer,
  fromStaticDataComplianceStatusesReducer,
  fromStaticDataJurisdictionRisksReducer,
  fromStaticDataPepRisksReducer,
  fromStaticDataMediaRisksReducer,
  fromStaticDataValueRisksReducer,
  fromProofOfBankDocumentTypesReducer,
  fromProofOfAddressDocumentTypesReducer,
  fromAccountTypesReducer,
  fromGoogleAPIKeyReducer,
  fromWithdrawalRejectionReasonReducer
};
